var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.projectDaten)?_c('div',{staticClass:"kontainer"},[_c('handwerker')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }